<template>
  <!-- //新闻动态子页 -->
  <div class="newstrend">
    <web-head :active="tab" @change="changeTab"></web-head>
    <div class="background type-page">
      <article class="contain flex-column-center">
        <section class="location">
          <span
            >您现在的位置是：<span
              @click="navPosition('column')"
              class="navPosition"
              >首页</span
            >>{{ this.name }}
          </span>
        </section>
        <!-- <div class="navbar" v-if="this.id !='1007' ">
          <input type="checkbox" id="tab-btn" checked />
          <ul class="flex-row-start1">
            <li
              v-for="(item, index) in tabClassify"
              :key="index"
              @click="changeCategory(item, index)"
            >
              <a
                href="javascript:;"
                :class="{ 'active-year': activeIndex1 === index }"
                >{{ item.name }}</a
              >
            </li>
            <div
              class="nav-mask"
              :style="{ transform: `translateX(${activeIndex1 * 120}px)` }"
            ></div>
          </ul>
        </div> -->
        <div class="newstrend-top">
          <div class="flex-row-center-start-space-between">
            <!-- <div class="newstrend-top-box">
              <ul>
                <li
                  @mouseover="changeractive(index)"
                  :class="index + 1 === newsIndex ? 'activeitem' : ''"
                  :key="index"
                  v-for="(item, index) in safetyList"
                >
                  <div class="flex-row-start">
                    <img src="../../../images/icons/newss.png" alt="" />
                    <a
                      href="javascript:;"
                      @click="navigator(item.id)"
                      v-html="showcontent(item.title)"
                    ></a>
                  </div>
                  <span>{{ item.releaseTime }}</span>
                </li>
              </ul>
            </div> -->
          </div>
          <div class="newstrend-line"></div>
          <div class="main-news">
            <div
              class="main-news-box m-n-loading"
              v-if="!safetyList.length"
            ></div>
            <div
              class="main-news-box"
              :key="item.id"
              v-for="item in safetyList"
              @click="navigator(item.id)"
            >
              <div class="main-news-date">
                <div id="dateDay">{{ item.dateDay }}</div>
                <div id="dateYear">{{ item.dateYear }}</div>
              </div>
              <div class="main-news-info">
                <div v-html="showcontent(item.title)"></div>
                <div
                  id="news-detail"
                  class="line-clamp-2"
                  :title="showcontent(item.description)"
                  v-html="showcontent(item.description)"
                ></div>
              </div>
            </div>
          </div>
          <div class="foot-pages" v-if="safetyList.length">
            <el-pagination
              :pager-count="5"
              prev-text="上一页"
              next-text="下一页"
              layout="prev, pager, next,jumper"
              background
              :current-page.sync="page"
              :page-size="8"
              @current-change="pagesChange"
              :total="totalCount"
            >
            </el-pagination>
          </div>
        </div>
      </article>
    </div>
    <web-foot></web-foot>
  </div>
</template>

<script scoped>
import {
  homeNewsList,
  newsTrend,
  newsTrend1,
  areaList,
  areaList1,
  getPVUV
} from "@apis/apis";
import Swiper from "swiper";
import Head from "@wigets/head.vue";
import Foot from "@wigets/foot.vue";
import { showcontent } from "@utils/method.js";
import "swiper/dist/css/swiper.css";
export default {
  components: {
    "web-head": Head,
    "web-foot": Foot,
  },
  loading: true,
  data() {
    return {
      //新闻列表
      newsList2: [],
      area: "",
      tab: 8,
      tabClassify: [
        { name: "全部", area: "" },
        { name: "国家级", area: 0 },
        { name: "省级", area: 1 },
      ],
      //新闻条数
      id: "",
      name: "安全生产",
      totalCount: 0,
      //当前的轮播图
      safetyList: [],
      activeIndex: 1,
      activeIndex1: 0,
      //轮播图
      swiper: null,
      //轮播图跳转时通过修改newsIndex修改新闻的样式
      newsIndex: 1,
      page: 1,
      pageSize: 8,
      //所有新闻
      totalList: [],
    };
  },
  watch: {
    /**
     * @description: 在newstrendList 传进来后渲染轮播图
     * @param {*}
     */
  },
  created() {
    console.log(this.$route.query);
    this.id = this.$route.query.id;
    if (this.id == "1005") {
      this.name = "会员风采";
    } else if (this.id == "1006") {
      this.name = "绿色发展";
    } else {
      this.name = "企业纾困";
      this.tab = 0;
    }
  },
  mounted() {
    // this.changnav()
    //获取新闻
    this.newsDetail();
    //渲染轮播图
    // this.renderSwiper()
    this.getpvuv()
  },
  activated() {
    this.changnav();
  },
  methods: {
    getpvuv(){
      this.$ajaxPost(getPVUV,{
        ip: sessionStorage.getItem('ip'),
        directoryOne: "法律法规",
        directoryTwo: "新闻详情",
        directoryThree: null,
        cookie: sessionStorage.getItem('random')
      })
    },
    showcontent,
    //防止刷新后父节点的值会改变
    changnav() {
      this.$emit("getMessage", 4);
      if (this.$route.query.page) {
        let page = this.$route.query.page;
        this.page = Number(page);
      } else {
        this.page = 1;
      }
    },
    /**
     * @description: 鼠标移动到新闻时轮播图跳转到相应sider
     * @param
     */

    changeractive(index) {
      this.activeIndex = index + 1;
      this.newsIndex = index + 1;
      //   this.swiper.slideTo(this.activeIndex, 1000, false)
    },
    // 好网贷分类展示
    changeCategory(item, index) {
      console.log(item);
      this.activeIndex1 = index;
      this.area = item.area;
      this.newsDetail();
      // this.year = year === '全部' ? '' : year;
      // this.productQuery.page = 1;
      // this.getGoodsList();
    },
    /**
     * @description: 每次切换tab时 渲染轮播图
     * @param {*}safetyList 轮播图列表
     */

    /**
     * @description: 新闻动态banner数据请求
     * @param {*} 根据渠道EC000201查询
     */
    // safety(channelNo) {
    //   this.$ajaxPost(`${homeNewsList}?categoryId=${channelNo}`, {
    //     page: 1,
    //     limit: 4,
    //   }).then((res) => {
    //     if (res.data.code != 0) {
    //       this.$message({
    //         title: "错误",
    //         type: "error",
    //         message: res.data.msg + ",请重新刷新",
    //       });
    //     } else {
    //       let list = res.data.data.list;
    //       list.forEach((e) => {
    //         e.title = showcontent(e.title);
    //         if (e.title.length >= 20) {
    //           e.title = e.title.substr(0, 20) + "...";
    //         }
    //       });
    //       this.safetyList = this.dateChecked(list);
    //     }
    //   });
    // },
    changeTab(val) {
      this.tab = val;
    },
    /**
     * @description: 新闻列表请求
     * @param {*} page 页数  limit 每页条数
     */

    newsDetail() {
      const loading = this.$loading({
        target: document.querySelector(".m-n-loading"),
      });
      this.$ajaxPost(`${homeNewsList}?categoryId=${this.id}`, {
        page: 1,
        limit: 8,
      })
        .then((res) => {
          if (res.data.code != 0) {
            this.$message({
              title: "错误",
              type: "error",
              message: res.data.msg + ",请重新刷新",
            });
          } else {
            let list = res.data.data.list;
            list.forEach((e) => {
              e.title = showcontent(e.title);
              if (e.title.length >= 20) {
                e.title = e.title.substr(0, 20) + "...";
              }
            });
            this.safetyList = this.dateChecked(list);
            // this.totalCount=res.data.data.totalCount
            // let list=res.data.data.list
            // this.newsList2 = this.dateChecked(list)
            this.pagesChange(this.page);
            loading.close();
          }
          // this.totalCount = res.data.data.totalCount
        })
        .catch((err) => {
          this.$alert(err + "网络请求异常，请稍后再试！", "警告", {
            confirmButtonText: "确定",
            type: "error",
            callback: () => {
              location.reload();
            },
          });
        });
    },
    //点击位置导航进行跳转
    navPosition(name) {
      this.$router.push({ name });
    },
    /**
     * @description: 新闻动态换页
     * @param {*} val为分页器参数
     */

    pagesChange(val) {
      this.$ajaxPost(`${homeNewsList}?categoryId=${this.id}`, {
        page: val,
        limit: 8,
      })
        .then((res) => {
          if (res.data.code != 0) {
            this.$message({
              title: "错误",
              type: "error",
              message: res.data.msg + ",请重新刷新",
            });
          } else {
            this.totalCount = res.data.data.totalCount;
            let list = res.data.data.list;
            this.safetyList = this.dateChecked(list);
          }
          this.totalCount = res.data.data.totalCount;
        })
        .catch((err) => {
          this.$alert(err + "网络请求异常，请稍后再试！", "警告", {
            confirmButtonText: "确定",
            type: "error",
            callback: () => {
              location.reload();
            },
          });
        });
    },
    /**
     * @description: 对后端数据返回的日期 年月日截取
     * @param {*} dateDay 日期的日号
     * @param {*} dateYear 日期的年月
     */

    dateChecked(list) {
      for (let item of list) {
        item.title = item.title.replace(/&ldquo;/g, '"');
        item.description = item.description.replace(/&ldquo;/g, '"');

        item.title = item.title.replace(/&rdquo;/g, '"');
        item.description = item.description.replace(/&rdquo;/g, '"');

        item.title = item.title.replace(/&quot;/g, '"');
        item.description = item.description.replace(/&quot;/g, '"');

        item.title = item.title.replace(/&mdash;/g, "—");
        item.description = item.description.replace(/&mdash;/g, "—");

        item.releaseTime = item.releaseTime.split(" ")[0];
        item.dateYear = item.releaseTime.slice(0, -3);
        item.dateDay = item.releaseTime.slice(-2);
      }
      // for (let i in list) {
      //   list[i].createTime = list[i].createTime.split(' ')[0]
      //   list[i].dateYear = list[i].createTime.slice(0, -3)
      //   list[i].dateDay = list[i].createTime.slice(-2)
      // }
      // console.log(list)
      return list;
    },

    /**
     * @description: 点击新闻跳转
     * @param {*}
     */

    navigator(id) {
      if (this.id == 1005) {
        this.$router.push({
          name: "newss",
          query: { id, checked: 7, page: this.page },
        });
      }else if(this.id == 1007){
        this.$router.push({
          name: "newss",
          query: { id, checked: 8, page: this.page },
        });
      }
    },
  },
};
</script>

<style lang="less" scoped>
@primary_color_1: #4878b3;
.newstrend {
  width: 100%;

  .contain {
    width: 100%;
    margin: 0rem auto;
    position: relative;
    section {
      width: 100%;
      margin-top: 0.2rem;
    }
    .location {
      width: 100%;
      margin-top: 0.2rem;
      // margin-bottom: 0.2rem;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      font-size: 0.14rem;
      letter-spacing: 0rem;
      color: #aaaaaa;
    }
  }
  @media all and (min-width: 750px) {
    width: 100%;
    box-sizing: border-box;
    .background {
      width: 10.3125rem;
      background-color: #f2f2f2;
      padding-bottom: 0.5rem;
    }
    li {
      list-style: none;
    }
    .newstrend-top {
      width: 100%;
      margin-top: 20px;
      background-color: #ffffff;

      border-radius: 0.1rem;
      overflow: hidden;
      .swiper {
        width: 2.191406rem;
        height: 1.804687rem;
        position: relative;
        .swiper-img {
          width: 100%;
          height: 100%;
          cursor: pointer;
        }
        .swiper-pagination {
          width: 3.48rem;
          height: 0.4rem;
          background-color: rgba(0, 0, 0, 0.3);
          bottom: 0;
          display: flex;
          justify-content: center;
          align-items: center;
          -webkit-transition: 300ms opacity;
          transition: 300ms opacity;
          -webkit-transform: translate3d(0, 0, 0);
          transform: translate3d(0, 0, 0);
          z-index: 100;
        }
        /deep/ .swiper-pagination-bullet {
          width: 0.085937rem;
          height: 0.085937rem;
          background-color: #ffffff;
        }
      }
      .newstrend-top-box {
        margin-left: 0.429687rem;
        margin-right: 0.429687rem;
        flex: 1;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        .activeitem {
          span {
            color: @primary_color_1 !important;
          }
          a {
            color: @primary_color_1;
          }
        }
        .line {
          display: block;
          width: 7.6rem;
          height: 0.02rem;
          background-color: #eeeeee;
        }
        ul {
          width: 100%;
          li {
            display: flex;
            color: #333;
            font-size: 0.1375rem;
            line-height: 0.429687rem;
            justify-content: space-between;
            a {
              width: 70%;
              color: #333;
              margin-left: 10px;
              text-align: left;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              font-size: 24px;
              font-weight: 500;
            }
            img {
              width: 18px;
              height: 18px;
              // margin-left: 10px;
              // margin-top: 15px;
              // vertical-align: middle;
            }
            span {
              color: #ccc9c9d3;
            }
          }
        }
      }
    }
    .newstrend-line {
    }
    .main-news {
      // width: 100%;
      padding: 0rem 0.2rem;
      .main-news-box {
        width: 100%;
        margin-top: 0.2rem;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: flex-start;
      }
      .main-news-box:hover {
        .main-news-date {
          div {
            color: #2d7fdd !important;
          }
        }
        .main-news-info {
          div {
            color: #3185e2 !important;
          }
          #news-detail {
            background: #608fc5 !important;
            color: #fff !important;
            border: 0.1rem solid #608fc5 !important;
          }
        }
      }
      .main-news-date {
        box-sizing: border-box;
        border: 1px solid #f4f4f4;
        width: 0.9rem;
        height: 0.8rem;
        border-radius: 0.1rem;
        margin-right: 0.1rem;
        display: flex;
        align-content: center;
        justify-content: center;
        flex-wrap: wrap;
        margin-top: 0.05rem;
        #dateDay {
          font-size: 0.4rem;
          line-height: 0.5rem;
          letter-spacing: 0rem;
          color: #999;
        }
        #dateYear {
          font-size: 0.14rem;
          line-height: 0.2rem;
          letter-spacing: 0rem;
          color: #999;
        }
      }
      .main-news-info {
        width: 10.5rem;
        text-align: left;
        cursor: pointer;
        div:first-child {
          font-size: 0.154687rem;
          line-height: 0.3rem;
          margin-bottom: 0.1rem;
          letter-spacing: 0rem;
          color: #333333;
        }
        #news-detail {
          height: 0.44rem;
          font-size: 0.1375rem;
          line-height: 0.22rem;
          letter-spacing: 0rem;
          color: #999999;
          background-color: #f4f4f4;
          border: 0.1rem solid #f4f4f4;
          border-radius: 6px;
          overflow: hidden;
          text-overflow: -o-ellipsis-lastline;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
      }
    }
    .foot-pages {
      margin-top: 0.4rem;
      margin-bottom: 0.3rem;
    }
  }
  @media screen and (max-width: 750px) {
  }
  .navbar {
    width: 100%;
    // padding:10px 0px;
    padding-bottom: 10px;
    border-bottom: 2px solid #dcdcdc;
    // margin-left: 50px;
    font-size: 0.14rem;
    .extend-btn {
      position: absolute;
      cursor: pointer;
    }
    ul {
      position: relative;
      display: flex;
      width: 0;
      height: 40px;
      line-height: 40px;
      background-color: #fff;
      overflow: hidden;
      transition: width 0.5s;
      cursor: pointer;
      li {
        width: 120px;
        z-index: 2;
        .active-year {
          color: #fff;
        }
      }
      a {
        color: #000;
        user-select: none;
      }
      .nav-mask {
        position: absolute;
        left: 0;
        top: 0;
        width: 120px;
        height: 100%;
        background-image: linear-gradient(
          -225deg,
          #4878b3 0%,
          #4878b3 50%,
          #4878b3 100%
        );
        // background-image: #4878b3;
        z-index: 0;
        transition: all 0.5s;
      }
    }
    span {
      // position: absolute;
      // left: .042969rem;
      top: calc(50% - 0.085937rem);
      width: 0.257812rem;
      height: 0.034375rem;
      background-color: #999;
      pointer-events: none;
      transform-origin: center center;
      transition: all 0.5s;
      &:nth-child(2) {
        top: calc(50% + 0.051562rem);
      }
    }
    > input {
      // width: 40px;
      // height: 40px;
      cursor: pointer;
      opacity: 0;
      &:checked ~ ul {
        width: 360px;
      }
      // &:checked ~ span {
      //   top: calc(50% - .017187rem);
      //   &:nth-child(2) {
      //     transform: rotate(-45deg);
      //   }
      //   &:nth-child(3) {
      //     transform: rotate(45deg);
      //   }
      // }
    }
  }
}
</style>
